import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { C } from '../theme';

const NAV = [
  { path: '/dealer/dashboard',          label: 'Dashboard',           icon: '📊' },
  { path: '/dealer/inventory',          label: 'Inventory',           icon: '📦' },
  { path: '/dealer/wallet',             label: 'Wallet',              icon: '💰' },
  { path: '/dealer/clients',            label: 'My Clients',          icon: '👥' },
  { path: '/dealer-mapping',            label: 'Dealer Mapping',      icon: '🗂️' },
  { path: '/dealer/credit-list',        label: 'Credit List',         icon: '💳' },
  { path: '/dealer/renewal-list',       label: 'Renewal List',        icon: '🔄' },
  { path: '/dealer/sales-history',      label: 'Sales History',       icon: '📈' },
  { path: '/dealer/renewal-history',    label: 'Renewal History',     icon: '🔁' },
  { path: '/dealer/replacement-history',label: 'Replacement History', icon: '🔃' },
];

export default function DealerLayout({ children, title }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: "'Segoe UI', sans-serif" }}>

      {/* Sidebar */}
      <aside style={{
        width: '210px', minWidth: '210px',
        background: C.sidebar,
        display: 'flex', flexDirection: 'column',
        position: 'sticky', top: 0, height: '100vh',
      }}>
        <div style={{ padding: '22px 20px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ fontSize: '17px', fontWeight: 800, color: C.primary, letterSpacing: '1px' }}>🐝 HIVE ERP</div>
          <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.3)', letterSpacing: '2px', marginTop: '2px' }}>DEALER PORTAL</div>
        </div>

        <nav style={{ flex: 1, padding: '10px 0' }}>
          {NAV.map(item => {
            const active = location.pathname.startsWith(item.path);
            return (
              <div
                key={item.path}
                onClick={() => navigate(item.path)}
                style={{
                  display: 'flex', alignItems: 'center', gap: '10px',
                  padding: '11px 18px', cursor: 'pointer', margin: '2px 8px', borderRadius: '8px',
                  background: active ? 'rgba(124,58,237,0.22)' : 'transparent',
                  color: active ? C.primary : 'rgba(255,255,255,0.55)',
                  fontWeight: active ? 700 : 400, fontSize: '13px',
                  transition: 'all 0.15s',
                }}
              >
                <span style={{ fontSize: '16px' }}>{item.icon}</span>
                {item.label}
              </div>
            );
          })}
        </nav>

        {/* User info + logout */}
        <div style={{ padding: '16px 18px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)', marginBottom: '4px' }}>Logged in as</div>
          <div style={{ fontSize: '13px', fontWeight: 600, color: 'rgba(255,255,255,0.8)', marginBottom: '10px' }}>
            {user?.full_name || user?.username}
          </div>
          <button onClick={handleLogout} style={{
            width: '100%', padding: '8px', background: 'rgba(239,68,68,0.12)',
            color: '#FCA5A5', border: '1px solid rgba(239,68,68,0.2)',
            borderRadius: '7px', fontSize: '12px', fontWeight: 600, cursor: 'pointer',
          }}>
            Sign Out
          </button>
        </div>
      </aside>

      {/* Main content */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: C.bg, minWidth: 0 }}>
        {/* Top bar */}
        <header style={{
          background: C.white, borderBottom: `1px solid ${C.border}`,
          padding: '16px 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <h1 style={{ fontSize: '18px', fontWeight: 700, color: C.textMain, margin: 0 }}>{title}</h1>
          <div style={{ fontSize: '12px', color: C.textSub, fontWeight: 500 }}>
            🏪 Dealer Panel
          </div>
        </header>

        <main style={{ flex: 1, padding: '28px' }}>
          {children}
        </main>
      </div>
    </div>
  );
}
